export default "__VITE_ASSET__CEyc13bx__"